// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-viewer-modal input,
.pdf-viewer-modal textarea,
.pdf-viewer-modal select,
.pdf-viewer-modal button {
  background: var(--neutral-white, #fff) !important;
  color: var(--almost-black, #222) !important;
}

/* Fix toolbar positioning */
.rpv-default-layout__toolbar {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
}

/* Fix container and viewer height/overflow */
.pdf-viewer-modal {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important;
  overflow: hidden !important;
}

.rpv-core__viewer {
  height: 100% !important;
  overflow: hidden !important;
}

.rpv-core__viewer-wrapper {
  height: 100% !important;
  overflow: auto !important;
}

/* Fix page container */
.rpv-core__page-layer {
  margin: 0 auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  min-height: 0 !important;
}

.rpv-core__inner-page {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.rpv-default-layout__body {
  overflow-y: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/Core/Components/PdfViewer/PdfViewer.css"],"names":[],"mappings":"AAAA;;;;EAIE,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".pdf-viewer-modal input,\n.pdf-viewer-modal textarea,\n.pdf-viewer-modal select,\n.pdf-viewer-modal button {\n  background: var(--neutral-white, #fff) !important;\n  color: var(--almost-black, #222) !important;\n}\n\n/* Fix toolbar positioning */\n.rpv-default-layout__toolbar {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1000 !important;\n}\n\n/* Fix container and viewer height/overflow */\n.pdf-viewer-modal {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100vh !important;\n  overflow: hidden !important;\n}\n\n.rpv-core__viewer {\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n.rpv-core__viewer-wrapper {\n  height: 100% !important;\n  overflow: auto !important;\n}\n\n/* Fix page container */\n.rpv-core__page-layer {\n  margin: 0 auto !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  min-height: 0 !important;\n}\n\n.rpv-core__inner-page {\n  margin-bottom: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.rpv-default-layout__body {\n  overflow-y: auto !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
